import styled from 'styled-components';
import { fontSizes, mediaQuery, paddings } from '~/styled';
import WebviewEnabledLink from '~/core/components/WebviewEnabledLink';

export const WrapperLink = styled(WebviewEnabledLink)`
  color: ${({ theme }) => theme.colors.onBackground};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 170px;
  gap: 20px;
  margin-top: ${paddings.tinyPadding};
  ${mediaQuery.down.s`
    gap: ${paddings.defaultPadding};
  `}
  &:visited,
  &:link,
  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export const LogoDiv = styled.div`
  height: 30px;
  width: 30px;
`;

export const SeparatorDiv = styled.div`
  display: block;
  width: 2px;
  height: 30px;
  background-color: ${({ theme }) => theme.colors.grey300};
`;

export const TitleDiv = styled.div`
  font-size: ${fontSizes.fontSizeBody};
  line-height: ${fontSizes.fontSizeBody};
  color: ${({ theme }) => theme.colors.onSurface};
  font-weight: 700;
`;
